//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Rater from '@/components/rater.vue';
import Reviewlist from '@/components/reviewlist.vue';
// import { mapGetters, mapActions } from 'vuex';
// import api from '../../api/index';
export default {
  components: {
    Rater,
    Reviewlist
  },
  name: 'rate',
  data() {
    return {};
  },
  methods: {
    // ...mapActions()
  },
  watch: {},
  computed: {
    // ...mapGetters()
  },
  created() {},
  mounted() {}
};
